function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-45 23.5 14.178)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.303 17.266L.302 4.474c0-.464.49-.755.884-.522l10.82 6.393a.61.61 0 010 1.046L1.189 17.788c-.393.232-.885-.058-.885-.522",
  fill: "#00ada7"
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#00ada7",
  strokeWidth: 5,
  cx: 21.504,
  cy: 10.517,
  rx: 10.5,
  ry: 10
}));

function SvgBalloon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 33"
  }, props), _ref);
}

export default SvgBalloon;